import axios from "axios";

// Image types all current browsers can display
const ALLOWED_CONTENT_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/avif",
];

const getImageIfImageContentType = async (url: string) => {
  if (!url.startsWith("http")) throw new Error("must use http/https protocol");
  try {
    const res = await axios.head(url);
    const contentType = res.headers?.["content-type"];
    // The header can include parameters, e.g. "image/jpeg; charset=binary"
    const mimeType =
      typeof contentType === "string"
        ? contentType.split(";")[0].trim().toLowerCase()
        : undefined;
    const isImage = mimeType ? ALLOWED_CONTENT_TYPES.includes(mimeType) : false;
    if (!isImage) throw new Error("not an image");
    return url;
  } catch (error) {
    throw new Error("request failed", { cause: error });
  }
};

export const getUrlsIfAreValidImages = async (urls: string[]) => {
  const preparedPromises = urls.map((url) => getImageIfImageContentType(url));
  const results = await Promise.allSettled(preparedPromises);
  return results.reduce<string[]>((acc, result) => {
    if (result.status === "fulfilled") {
      return [...acc, result.value];
    }
    return acc;
  }, []);
};
